import React, { createContext, useEffect, useState } from 'react';
import { GoogleAuthProvider, signOut, signInWithPopup } from 'firebase/auth';
import { auth, db } from '../utils/firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';

export const AuthContext = createContext();
export const useAuthentication = () => React.useContext(AuthContext);

export const AuthContextProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // Start loading as true
    const [adminEmails, setAdminEmails] = useState([]); // Store admin emails
    const googleProvider = new GoogleAuthProvider();

    const googleLogin = async () => {
        try {
            await signInWithPopup(auth, googleProvider);
        } catch (error) {
            console.error("Error during login: ", error);
        }
    };

    const googleLogout = async () => {
        await signOut(auth);
        setUser(null);
        console.log("Logged out successfully");
    };

    // Fetch admin emails from Firestore on component mount
    useEffect(() => {
        const fetchAdminEmails = async () => {
            const adminEmailsRef = collection(db, "admins");
            try {
                const snapshot = await getDocs(adminEmailsRef);
                const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setAdminEmails(data[0]?.ids || []); // Ensure you handle the case when data[0] is undefined
            } catch (error) {
                console.error("Error getting documents:", error);
            }
        };

        fetchAdminEmails();
    }, []);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                console.log(user.email);
                // Only check email if adminEmails has been populated
                if (adminEmails.length > 0) {
                    if (adminEmails.includes(user.email)) {
                        setUser(user);
                        console.log("Admin logged in:", user.email);
                    } else {
                        console.log("Not an admin, logging out");
                        await googleLogout();
                    }
                }
            }
            setLoading(false); // Set loading to false after checking the user
        });

        return unsubscribe;
    }, [adminEmails]); // Dependency on adminEmails

    // Function to update loading state
    const updateLoading = (status) => {
        setLoading(status);
    };

    const value = {
        user,
        googleLogin,
        googleLogout,
        loading,
        updateLoading // Exporting updateLoading
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children} {/* Only render children when not loading */}
        </AuthContext.Provider>
    );
};